import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DOCUMENT,
  ElementRef,
  Inject,
  Input,
  Renderer2,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy
} from '@angular/core';
import * as _ from 'lodash-es';
import {TableColumnReorderColumnMeta} from './table-column-reorder-column-meta';
import {TableColumnReorderColumnsArea} from './table-column-reorder-columns-area';

const TABLE_COLUMN_MOVING_GHOST_CLASS = 'table-column-reorder-ghost';

@Component({
    selector: 'table-column-moving-ghost',
    template: '<ng-container #innerContent></ng-container>',
    styleUrls: ['./table-column-moving-ghost.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableColumnMovingGhostComponent implements AfterViewInit {

    @Input()
    public movingArea: TableColumnReorderColumnsArea;

    @Input()
    public initialShift: number = 0;

    @ViewChild('innerContent', {read: ViewContainerRef, static: true})
    private innerViewContainerRef: ViewContainerRef;

    private initialPositionLeft: number;

    constructor(
        @Inject(DOCUMENT)
        private document: Document,
        private renderer: Renderer2,
        private elementRef: ElementRef,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngAfterViewInit(): void {
        this.render();
    }

    public updateShift(shift: number): void {
        this.setElementStyles(this.elementRef.nativeElement, {
            left: `${this.initialPositionLeft + shift}px`
        });
    }

    private render(): void {

        // Prepare the ghost container element.

        const {top: baseTop, left: baseLeft} = this.elementRef.nativeElement.getBoundingClientRect();

        this.initialPositionLeft = this.movingArea.rect.left - baseLeft;

        this.setElementStyles(this.elementRef.nativeElement, {
            top: `${this.movingArea.rect.top - baseTop}px`,
            left: `${this.initialPositionLeft + this.initialShift}px`
        });

        // Render the column ghosts inside the container.

        this.movingArea.columns.forEach(columnMeta => this.createColumnElement(columnMeta));
        this.changeDetectorRef.detectChanges(); // Render the column elements content.
    }

    private createColumnElement(columnMeta: TableColumnReorderColumnMeta): void {
        const columnGhostViewRef = columnMeta.columnDirective.render(this.innerViewContainerRef);
        const columnGhostElement: HTMLElement = columnMeta.columnDirective.getElement(columnGhostViewRef);
        const {left: columnLeft} = columnMeta.element.getBoundingClientRect();

        const style = this.document.defaultView.getComputedStyle(columnMeta.element);

        this.setElementStyles(columnGhostElement, {
            display:         'block',
            position:        'absolute',
            top:             '0',
            left:            `${columnLeft - this.movingArea.rect.left}px`,
            width:           style.width,
            height:          style.height,
            boxSizing:       style.boxSizing,
            webkitBoxSizing: style.webkitBoxSizing,
            padding:         style.padding,
            font:            style.font,
            textAlign:       style.textAlign,
            textOverflow:    style.textOverflow,
            whiteSpace:      style.whiteSpace,
            overflow:        style.overflow
        });

        columnGhostElement.classList.add(TABLE_COLUMN_MOVING_GHOST_CLASS);
    }

    private setElementStyles(element: HTMLElement, styles: Partial<CSSStyleDeclaration>): void {
        _.forEach(styles, (value, key: string) =>
            this.renderer.setStyle(element, key, value)
        );
    }

}
